// extracted by mini-css-extract-plugin
module.exports = {"root":"Datepicker_root__dWD8i","value":"Datepicker_value__2gyr3"};